// const path = require("path")

exports.categoryNames = ["dissidents-de", "dissidents-ru"]


exports.metaInfos = [
  {
    langId: "de",
    name: "дekóder",
    title: "Anders sein",
    subtitle: "Dissens in der Sowjetunion",
    description: "",
    defaultSocialImg: "https://specials.dekoder.org/content/uploads/2021/12/dissident_social_de.jpg",
    info: [
      {
        title: "Impressum",
        url: "https://www.dekoder.org/impressum",
      },
      {
        title: "Datenschutz",
        url: "https://www.dekoder.org/de/datenschutzerklaerung",
      },
    ],
  },
  {
    langId: "ru",
    name: "дekóder",
    title: "Быть другим ",
    subtitle: "инакомыслие в СССР",
    description: "",
    defaultSocialImg: "https://specials.dekoder.org/content/uploads/2021/05/dissident_social_ru2.png",
    info: [
      {
        title: "Правовая информация",
        url: "https://www.dekoder.org/ru/pravovaya-informaciya",
      },
      {
        title: "Политика по защите персональных данных",
        url: "https://www.dekoder.org/ru/politika-po-zashchite-personalnyh-dannyh",
      },
    ],
  },
]

exports.siteMetadata = {
  title: `Dissidenten`,
  description: ``,
  siteUrl: `https://dissident.dekoder.org`,
  author: `dekoder.org`,
}

exports.placeholder = {
  de: "<h1>Andrej Sacharow</h1><p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.</p><h1>Ry Nikonowa</h1><p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.</p><h1>Natalja Gorbanewskaja</h1><p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.</p>",
  en: "<p>This text is not published yet.</p>",
  ru: "<p>Русская версия будет опубликована позже.</p>",
  uk: "<p>This text is not published yet.</p>",
}

exports.pathPrefix = ""
exports.faviconPath = `src/images/favicon.png`
exports.layoutComponentPath = require.resolve("./src/components/layout")
exports.graphqlApi = `https://wp.dekoder.org/wp/graphql` // `https://dekoder-wp-stage.palasthotel.de/wp/graphql`
exports.restApi = `https://wp.dekoder.org/wp-json/wp/v2/posts` // `http://localhost:8080/wp-json/wp/v2/posts` //

exports.trackingId = "UA-66707787-11"

exports.socialImgComp = require.resolve(
  "./src/components/social-image/social-image.js"
)
